import styled from "styled-components";

import { Button } from "../../../components";

export const ToggleFiltersButton = styled(Button)`
  height: 48px;
  width: 56px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
